import { ArrowRight, CalendarRange, Building2, Clock, UtensilsCrossed, Users } from "lucide-react";

const ITEMS = [
  { title: "Weekly stay options", icon: CalendarRange, note: "Availability shared on enquiry" },
  { title: "Monthly stay options", icon: Building2, note: "Comfortable for long-term guests" },
  { title: "Custom duration", icon: Clock, note: "From a weekend to several weeks" },
  { title: "Meal preferences", icon: UtensilsCrossed, note: "Veg, non-veg, children, elderly-friendly" },
  { title: "Number of guests", icon: Users, note: "Discussed during enquiry" },
];

export default function ExtendedStays() {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="extended" className="py-24 md:py-32 bg-[#2C392F] text-[#F7F5F0] dark-section relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-50 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-6 reveal">
            <div className="text-[11px] uppercase tracking-[0.35em] text-[#C8A189] mb-5">Stay longer</div>
            <h2 className="serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tightest font-light">
              Stay for a weekend. <span className="italic text-[#D89B7E]">Settle in for longer.</span>
            </h2>

            <p className="mt-8 text-[#F7F5F0]/75 text-base md:text-lg leading-relaxed max-w-xl">
              ChiMano House is available for both short and extended stays. Its spacious layout, caretaker
              support, cooking arrangements, modern amenities and nearby grocery access make it especially
              comfortable for guests who wish to stay for several weeks or more.
            </p>

            <button
              data-testid="cta-button-long-stay"
              onClick={() => go("enquire")}
              className="mt-10 inline-flex items-center gap-2 bg-[#985F47] hover:bg-[#86513A] text-[#F7F5F0] px-7 py-4 rounded-full text-[12px] tracking-[0.2em] uppercase transition-all"
            >
              Ask About Long-Stay Availability <ArrowRight size={16} />
            </button>
          </div>

          <div className="lg:col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {ITEMS.map((it, i) => {
              const Icon = it.icon;
              return (
                <div
                  key={it.title}
                  data-testid={`extended-stay-card-${i}`}
                  className={`reveal bg-white/[0.04] border border-white/10 rounded-2xl p-6 hover:bg-white/[0.07] transition-all ${
                    i === 0 ? "sm:translate-y-6" : ""
                  } ${i === 4 ? "sm:col-span-2" : ""}`}
                >
                  <Icon className="text-[#D89B7E]" size={22} strokeWidth={1.4} />
                  <div className="serif text-[22px] mt-5 leading-tight">{it.title}</div>
                  <div className="text-xs uppercase tracking-[0.2em] text-[#F7F5F0]/45 mt-2">{it.note}</div>
                </div>
              );
            })}
          </div>
        </div>

        <p className="mt-10 text-[12px] uppercase tracking-[0.25em] text-[#F7F5F0]/40">
          Pricing shared on enquiry · No fixed packages
        </p>
      </div>
    </section>
  );
}
